import React from "react";
import SEO from "../seo/SEO";

const Thanks = () => {
  return (
    <div className="thank-you-wrapper d-flex justify-content-center align-items-center">
      <SEO pageKey="thanks" />
      <div className="text-center">
        <div className="icon">
          <img src="/assets/logo.svg" alt="Thank You Icon" className="img-fluid" />
        </div>

        <h2 className="thank-you-title mb-2">Thanks for submitting!</h2>
        <p className="thank-you-message mb-4">Your message has been sent!</p>

        <a href="/" className="btn-lightGreen">Go Home</a>
      </div>
    </div>
  );
};

export default Thanks;
